import { ProductUtils, ValidationResultFail } from '@inter-ikea-core/core';
import { ValidationBase } from '@inter-ikea-core/core-toolbox';
import SettingsComponent from '../components/SettingsComponent';
/**
 * Class responsible for validating stacking. The general settings are checked to determine if stacking is allowed.
 * Setting is set in DEXF under general settings -> disableFrameStacking.
 */
export class StackingDisabledValidation extends ValidationBase {
    /**
     * Constructor for StackingDisabledValidation.
     * @param coreApi - The core API instance.
     */
    constructor(coreApi) {
        super();
        this.name = 'StackingDisabledValidation';
        this.id = 'STACKING_DISABLED_VALIDATION';
        /**
         * Checks if the snap action candidate is a stacking action on top of another stacking host.
         * @param snapActionCandidate - The snap action candidate.
         * @returns {boolean} - True if it is a stacking action, false otherwise.
         */
        this.isStacking = (snapActionCandidate) => {
            return (snapActionCandidate.guestConnector.key === 'stacking-guest' &&
                snapActionCandidate.guestConnector.enabled);
        };
        this.coreApi = coreApi;
    }
    /**
     * Validates the current state.
     * @returns {ValidationResult | null} - The validation result or null if no validation is needed.
     */
    validateCurrentState() {
        return null;
    }
    /**
     * Validates the snap action.
     * @param snapActionCandidate - The snap action candidate.
     * @returns {ValidationResult | null} - The validation result or null if the snap action is valid.
     */
    validateSnap(snapActionCandidate) {
        const entity = snapActionCandidate.guestRoot;
        const settings = this.coreApi.entities
            .getScene()
            ?.getComponent(SettingsComponent.id);
        if (this.isStacking(snapActionCandidate) && settings?.disableFrameStacking === true)
            return new ValidationResultFail('Frame stacking is disabled', ProductUtils.productRefOrEmptyString(entity));
        return null;
    }
}
//# sourceMappingURL=StackingDisabledValidation.js.map